import {Component, Inject, OnInit} from '@angular/core';
import {FormGroup, UntypedFormBuilder, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ProjectTypesService} from "@core/services/backend/common/service/project-types.service";
import {ProjectType} from "@core/services/backend/common/interface/project-types";

@Component({
    selector: 'vex-project-types-create-update',
    templateUrl: './project-types-create-update.component.html',
    styleUrls: ['./project-types-create-update.component.scss']
})
export class ProjectTypesCreateUpdateComponent implements OnInit {

    form: FormGroup;
    mode: 'create' | 'update' = 'create';

    constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
                private dialogRef: MatDialogRef<ProjectTypesCreateUpdateComponent>,
                private fb: UntypedFormBuilder,
                private translateService: TranslateService,
                private snackbar: MatSnackBar,
                private projectTypes: ProjectTypesService) {
    }

    ngOnInit() {
        if (this.defaults) {
            this.mode = 'update';
        } else {
            this.defaults = {} as ProjectType;
        }

        this.form = this.fb.group({
            id: [this.defaults.id || null],
            name: [this.defaults.name || '', [Validators.required]],
            active: [this.defaults.active !== false],
            mostrarListaNiveles: [this.defaults.mostrarListaNiveles === true]
        });
    }

    save() {
        if (this.mode === 'create') {
            this.create();
        } else if (this.mode === 'update') {
            this.update();
        }
    }

    create() {
        const projectType = this.form.value;
        delete projectType.id;
        this.projectTypes.create(projectType).subscribe({
            next: (result) => {
                this.snackbar.open('Tipo de Proyecto creado correctamente', '', {
                    duration: 3000
                });
                this.dialogRef.close(result);
            },
            error: (err) => {
                this.snackbar.open('Error al crear el tipo de proyecto', '', {
                    duration: 3000
                });
            }
        });
    }

    update() {
        const projectType = this.form.value;
        this.projectTypes.update(projectType).subscribe({
            next: (result) => {
                this.snackbar.open('Tipo de Proyecto actualizado correctamente', '', {
                    duration: 3000
                });
                this.dialogRef.close(result);
            },
            error: (err) => {
                this.snackbar.open('Error al actualizar el tipo de proyecto', '', {
                    duration: 3000
                });
            }
        });
    }

    cancel() {
        this.dialogRef.close();
    }
}

